<div class="pr-tainer compliance-page">
  <div class="container">
    <div class="header-row">
      <div>
        <h3 class="page-title">Adherence Profiler</h3>
      </div>
    </div>
    <div class="compliance-card">
      <div class="compliance-toggle-row">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="complianceRuleEnabled">
          <span class="slider round"></span>
        </label>
        <span class="compliance-rule-title section-title">Adherence Profiler</span>
      </div>
    </div>
  </div>
</div>
